export function Sprig({ className }: { className?: string }) {
  return (
    <svg
      className={className ? `sprig ${className}` : "sprig"}
      viewBox="0 0 240 24"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1">
        <line x1="0" y1="12" x2="88" y2="12" />
        <line x1="152" y1="12" x2="240" y2="12" />
      </g>
      <circle cx="96" cy="12" r="1.4" fill="currentColor" />
      <circle cx="144" cy="12" r="1.4" fill="currentColor" />
      <path
        d="M114 11.4c-6.2-.9-9.6-4-10.4-8.4 4.5.6 8.6 3.6 10.4 8.4Z"
        fill="currentColor"
        opacity="0.85"
      />
      <path
        d="M126 11.4c6.2-.9 9.6-4 10.4-8.4-4.5.6-8.6 3.6-10.4 8.4Z"
        fill="currentColor"
        opacity="0.85"
      />
      <path
        d="M114 12.6c-6.2.9-9.6 4-10.4 8.4 4.5-.6 8.6-3.6 10.4-8.4Z"
        fill="currentColor"
        opacity="0.55"
      />
      <path
        d="M126 12.6c6.2.9 9.6 4 10.4 8.4-4.5-.6-8.6-3.6-10.4-8.4Z"
        fill="currentColor"
        opacity="0.55"
      />
      <path d="M120 8.4 123.6 12 120 15.6 116.4 12Z" fill="currentColor" />
    </svg>
  );
}

export function Seal({ className }: { className?: string }) {
  return (
    <span className={className ? `seal ${className}` : "seal"} aria-hidden="true">
      <span className="seal-letter">E</span>
      <span className="seal-script">i</span>
      <span className="seal-letter">M</span>
    </span>
  );
}
